import { render, staticRenderFns } from "./a-guide-overview-button.vue?vue&type=template&id=24cda1d3&"
import script from "./a-guide-overview-button.vue?vue&type=script&lang=js&"
export * from "./a-guide-overview-button.vue?vue&type=script&lang=js&"
import style0 from "./a-guide-overview-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports